import { collection, doc, getDoc, getDocs, setDoc, Timestamp } from "firebase/firestore";
import { db } from "../firebase";
import Lang from "../models/Lang";

const getLang = async (lang: string) => {
    const colRef = doc(db, "lang", lang);
    const querySnapshot = await getDoc(colRef);
    if (querySnapshot.exists()) {
        return querySnapshot.data() as Lang;
    }
    throw new Error("Lang not found");
}

const getLangs = async (): Promise<Lang[]> => {
    const querySnapshot = await getDocs(collection(db, "lang"));
    const langs: Lang[] = [];
    querySnapshot.forEach((doc) => {
        const lang = doc.data() as Lang;
        lang.uid = doc.id;
        langs.push(lang);
    });
    return langs;
}

const addLangData = async (lang: string, key: string, value: string) => {
    const colRef = doc(db, "lang", lang);
    const querySnapshot = await getDoc(colRef);
    if (querySnapshot.exists()) {
        const langData = querySnapshot.data() as Lang;
        langData.data[key] = value;
        await setDoc(colRef, langData);
    } else {
        throw new Error("Lang not found");
    }
}

const deleteLangData = async (lang: string, key: string) => {
    const colRef = doc(db, "lang", lang);
    const querySnapshot = await getDoc(colRef);
    if (querySnapshot.exists()) {
        const langData = querySnapshot.data() as Lang;
        delete langData.data[key];
        await setDoc(colRef, langData);
    } else {
        throw new Error("Lang not found");
    }
}

const createLang = async (lang: string) => {
    const colRef = doc(db, "lang", lang);
    const querySnapshot = await getDoc(colRef);
    if (!querySnapshot.exists()) {
        const langData: Partial<Lang> = {
            data: {},
            createdAt: Timestamp.fromDate(new Date()),
            updatedAt: Timestamp.fromDate(new Date()),
        }
        await setDoc(colRef, langData);
    } else {
        throw new Error("Lang already exists");
    }
}

const LangController = {
    getLang,
    getLangs,
    addLangData,
    deleteLangData,
    createLang
}
export default LangController;